/**
 * International Recruitment (Philippines) - shared constants.
 * Client-safe: no DB access, importable from pages and API routes alike.
 */

export const PHILIPPINES_COUNTRY = 'Philippines';

/** recruitment_sources row seeded by recruitment_international_ph_2026_07_30.sql */
export const PHILIPPINES_SOURCE = 'Philippines Recruitment';

/**
 * Default position for PH candidates. Contains "teli" so
 * resolveTrainingTrackFromPositionApplied routes them to the TELI training
 * track, and is NOT 'Full Time (Regular)' so the Stage-2 scorecard stays
 * optional (same as existing Teli candidates).
 */
export const PH_DEFAULT_POSITION = 'Full Time (Teli Remote)';

export function isPhilippinesCandidate(
  candidate: { country?: string | null } | null | undefined
): boolean {
  return candidate?.country === PHILIPPINES_COUNTRY;
}

export type ExternalLinkPurpose = 'application' | 'psychometric';

/** External link lifetime: links expire this many hours after the candidate FIRST OPENS them (not after generation). */
export const EXTERNAL_LINK_TTL_HOURS = 3;

/** Public (no-login) candidate-facing paths. Client prefixes window.location.origin. */
export const EXTERNAL_APPLY_PATH = (token: string) => `/careers/ph/apply/${token}`;
export const EXTERNAL_TEST_PATH = (token: string) => `/careers/ph/test/${token}`;

/**
 * Shared pre-funnel intake landing (recruitment_intake_link token). Candidates
 * start here; Start creates a draft application whose draft_token then rides
 * the same EXTERNAL_APPLY_PATH wizard URL space.
 */
export const EXTERNAL_JOIN_PATH = (token: string) => `/careers/ph/join/${token}`;

export function externalPathForPurpose(purpose: ExternalLinkPurpose, token: string): string {
  return purpose === 'application' ? EXTERNAL_APPLY_PATH(token) : EXTERNAL_TEST_PATH(token);
}

export type PsychometricLanguage = 'es' | 'en';

export function parsePsychometricLanguage(value: unknown): PsychometricLanguage | null {
  return value === 'es' || value === 'en' ? value : null;
}
